

import logo from '../../../Assets/images/logo.svg'
import AuthorSideBar from '../../../components/Layout/AuthorSideBar';
import Button from '../../../components/Ui/Button';
import CompanyProfileValidation from '../../../yup/Profile/ProfileValidation';
import React, { KeyboardEventHandler, useEffect, useState } from 'react';
import { capitalizeFirstLetter, getLocationAddress, handleShowSwalConfirmation, validImageTypes, validateImage } from '../../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import { CategoryAction, CompanyProfileAction, DetailProfileAction, GetProfileAction, ProfileGetCategoryAction, RemoveProfileImageAction } from '../../../redux/Action/ProfileAction';
import { useNavigate } from 'react-router-dom';
import { Config } from '../../../config/Config';
import CreatableSelect from 'react-select/creatable';
import Spinner from '../../../components/Spinner';
import ProfileImageItem from './ProfileImageItem';
import ProfileLocation from './ProfileLocation';
import { RemoveImage, handleImageChange, handleOwnerImageChange } from './Image';
import Errormessages from '../../../components/ErrorMessage/Errormessages';
import CommanForm from '../../../components/FormController/Commanform';

import { FormattedMessage, useIntl } from 'react-intl';

const components = {
    DropdownIndicator: null,
};

interface Option { readonly label: string; readonly value: string; }

const createOption = (label: string) => ({ label, value: label });





const Profile = () => {
    const intl = useIntl();


    const dispatch = useDispatch<any>();
    const navigate = useNavigate();

    const [selectedImages, setSelectedImages]: any = useState<Array<{ file_path: string | null, media_id: number | string | null }>>([
        { file_path: null, media_id: null }, { file_path: null, media_id: null }, { file_path: null, media_id: null },
        { file_path: null, media_id: null }, { file_path: null, media_id: null },
    ]);

    const [ownerImage, setOwnerImage]: any = useState(null)
    const [ownerImageData, setOwnerImageData]: any = useState(null)
    const [categoryData, setCategoryData]: any = useState([])
    const [inputValue, setInputValue] = React.useState('');
    const [value, setValueData] = React.useState<readonly Option[]>([]);
    const [selectedCategories, setSelectedCategories]: any = useState([]);
    const [getImages, setGetImages] = useState(Array(0).fill(null));
    const [isLoading, setIsLoading] = useState(false);

    const [latitude, setLatitude]: any = useState(null)
    const [longitude, setLongitude]: any = useState(null)

    const categoryState = useSelector((state: any) => state.ProfileGetCategoryState);
    const companyProfile = useSelector((state: any) => state.CompanyProfileState);
    const detail_profile = useSelector((state: any) => state.DetailProfileState);
    const profile_data = useSelector((state: any) => state.GetProfileState);

    const [isLoadingData, setIsLoadingData] = useState(true);

    const { register, watch, setValue, errors, handleSubmit, trigger, setError, clearErrors } = CommanForm({
        validationSchema: CompanyProfileValidation, defaultValues: { description: '', location: '', category: [], services: [] as any, image: [], ownerimage: '' }
    });

    const handleImage = (e: any, index: number) => { handleImageChange({ e, index, selectedImages, setSelectedImages, setValue, trigger, validateImage, validImageTypes, getImages, setGetImages }) };
    const handleImageAdd = () => { setSelectedImages([...selectedImages, { file_path: null, media_id: null }]) };
    // const handleRemoveImage = async (media_id: number | string | null, index: number) => { await RemoveImage({ media_id, index, selectedImages, setSelectedImages, setValue, trigger, dispatch }) };
    const handleOwnerImage = (e: any) => { handleOwnerImageChange({ e, setValue, setOwnerImage, validateImage, validImageTypes }) };

    const handleRemoveImage = async (media_id: any, index: any) => {
        let imageData: any[] = [];

        // let confirmation = await handleShowSwalConfirmation("You want to remove this image?", true);
        let confirmation = await handleShowSwalConfirmation(intl.formatMessage({ id: 'you_want_to_remove' }), true, true, intl.formatMessage({ id: 'are_you_sure' }));

        if (confirmation) {

            let updatedImages;

            if (media_id) {
                updatedImages = selectedImages.filter((img: any) => img.media_id !== media_id);
            } else {
                updatedImages = [...selectedImages];
                updatedImages.splice(index, 1);
            }



            setSelectedImages(updatedImages);
            imageData = updatedImages.filter((item: any) => item?.file_path != null);

            if (imageData.length >= 5) {
                setValue('image', imageData);
            }
            else {
                setValue('image', []);
            }
            trigger("image");

            if (media_id) {
                dispatch(RemoveProfileImageAction({ delete_id: media_id }));
            }
        }
    }
    const handleLocationSuccess = (result: any) => {
        setLatitude(result?.latitudeLongitude?.lat)
        setLongitude(result?.latitudeLongitude?.lng)
        setValue('location', result?.formattedAddress)
        trigger('location')
    }


    const handleCurrentLocation = async () => {
        const address: any = await getLocationAddress({ type: 'current' });
        setLatitude(address?.latitude)
        setLongitude(address?.longitude)
        if (address?.status === 'SUCCESS') {
            setValue('location', address?.address)
            trigger("location")
        };
    }

    const onSubmit = (payload: any) => {


        const formData = new FormData();
        for (let i = 0; i < getImages.length; i++) {
            formData.append('buisness_images', getImages[i]);
        }

        let arr: any = []
        payload?.services.length > 0 && payload?.services?.map((item: any) => {
            arr.push(item?.value)
        });

        let cat: any = []

        payload?.category?.length && payload?.category?.map((item: any) => {
            cat.push(item)
        });

        const servicesJSON = JSON.stringify(arr);
        const categoriesJSON = JSON.stringify(cat);

        formData.append("owner_image", ownerImage ? ownerImage : "")
        formData.append("location", payload?.location)
        formData.append("description", payload?.description)
        formData.append("categories", categoriesJSON)
        formData.append("services", servicesJSON)
        formData.append("s_lat", latitude)
        formData.append("s_long", longitude)

        dispatch(CompanyProfileAction(formData))
    }

    useEffect(() => {
        if (companyProfile?.status) {
            if (Config?.IS_USER_LOGIN_TOKEN) {
                dispatch(GetProfileAction({}))
            }
            const fetch = async () => {
                Config.USER_DETAILS.is_profile_setup = 1
                navigate("/complete-profile")
                // navigate("/profile")
            }
            fetch()
        }
    }, [companyProfile])





    useEffect(() => {
        if (categoryState?.status) {
            setCategoryData(categoryState?.data?.data)
        }
    }, [categoryState]);

    useEffect(() => {
        if (profile_data?.data?.data?.is_profile_setup == 2 && Config?.USER_DETAILS?.role_id == 1) {
            setIsLoading(true);
            navigate("/")
        }
    }, [profile_data])



    if (isLoading || profile_data?.loading) {
        return <>
        </>
    }

    useEffect(() => {
        setValue('services', value);
    }, [value, setValueData]);



    const handleKeyDown: KeyboardEventHandler = (event) => {
        trigger("services");
        setError("services", { type: 'custom', message: '' })

        if (!inputValue) return;
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                setValueData((prev) => [...prev, createOption(inputValue)]);
                setInputValue('');
                event.preventDefault();
        }
    };





    useEffect(() => {
        dispatch(DetailProfileAction({ type: 1 }));
        dispatch(ProfileGetCategoryAction({}));
        setIsLoadingData(false);
    }, [])

    useEffect(() => {
        if (detail_profile?.status) {
            const { location = '', description = '', categories = [], services = [], buisness_images = [], owner_image = {} } = detail_profile?.data?.data || {};

            setValue('location', location ? location : '')
            setValue('description', description ? description : "")
            setOwnerImageData(owner_image?.file_path)
            setValue("ownerimage", owner_image?.file_path ? owner_image?.file_path : '')

            if (services) {
                const servicesData: any = JSON.parse(services || [])
                const formattedServices = Array.isArray(servicesData) ? servicesData.map((service) => createOption(service)) : [];
                setValueData(formattedServices);
                setValue('services', formattedServices);
            }

            if (categories) {
                let categoryIds: any = categories.map((category: any) => category?.category_detail?.id).filter((id: any) => id !== undefined) || [];
                setSelectedCategories(categoryIds ? categoryIds : "")
                setValue("category", categoryIds ? categoryIds : "")
            }

            if (buisness_images?.length > 0) {
                const businessImages = buisness_images.map((image: any) => ({
                    file_path: image.file_path,
                    media_id: image.media_id,
                }));
                setSelectedImages(businessImages);
                setValue("image", businessImages);
            }

        }
    }, [detail_profile])


    /* ************ check box categories start ************ */
    const handleCheckboxChange = (categoryId: any) => {
        setSelectedCategories((prevSelectedCategories: any) => {
            const newSelectedCategories = prevSelectedCategories.includes(categoryId) ? prevSelectedCategories.filter((id: any) => id !== categoryId)
                : [...prevSelectedCategories, categoryId];
            setValue('category', newSelectedCategories);
            if (newSelectedCategories.length === 0) {
                setError('category', { type: 'custom', message: 'At least one category must be selected' });
            } else {
                clearErrors('category');
                trigger('category');

            }
            trigger('category');

            return newSelectedCategories;
        });
    };
    /* ************ check box categories end ************ */


    if (isLoadingData) {
        return <Spinner />;
    }



    return (
        <>
            {/* { <Spinner />} */}
            {profile_data?.loading || categoryState?.loading ? <Spinner /> : ""}

            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-lg-4 d-none d-lg-block'>
                        <AuthorSideBar />
                    </div>
                    <div className='col-lg-8'>
                        <div className='loginRIght'>
                            <div className='loginTOp text-center text-md-end py-4'><img alt='logo' src={logo} /></div>
                            <h1><FormattedMessage id="company_profile_setup" /></h1>
                            <p><FormattedMessage id="add_company_details" /></p>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='row mt-4'>
                                    <div className='col-lg-12 col-xxl-10'>
                                        <div className='inputIcon mb-4'>
                                            <label className="form-label"><FormattedMessage id="location" />*</label>
                                            <ProfileLocation
                                                id='home-pickup-input'
                                                className="form-control exclamation-bg"
                                                onSuccess={handleLocationSuccess}
                                                value={watch("location")}
                                                placeholder={intl.formatMessage({ id: 'enter_location' })}

                                                onChange={(e) => {
                                                    setValue('location', e?.target?.value)
                                                    trigger('location')
                                                }}
                                            />

                                            <span className="iconLeft icon-location"></span>
                                            <span className="iconRight icon-gps" onClick={handleCurrentLocation}></span>
                                            <Errormessages errors={errors} name="location" />
                                        </div>
                                        <div className='inputNOTIcon mb-4'>
                                            <label className="form-label"><FormattedMessage id="salon_description" />*</label>
                                            <textarea className='form-control' placeholder={intl.formatMessage({ id: 'write_description' })}
                                                {...register("description")}
                                                onInput={(e: any) => {
                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                    setValue("description", value);
                                                }}
                                            ></textarea>
                                            <Errormessages errors={errors} name="description" />

                                        </div>

                                        <div className='category'>
                                            <h6><FormattedMessage id="Categories" />*<small>(<FormattedMessage id="select_categories_in_which_your." />)</small></h6>
                                            <ul>
                                                {
                                                    categoryData?.length > 0 && categoryData.map((item: any, index: any) => (

                                                        <li key={index}>
                                                            <input type="checkbox" className="btn-check"
                                                                id={`option-${index}`}
                                                                value={item.id}
                                                                {...register("category")}
                                                                checked={selectedCategories.includes(item.id)}
                                                                onChange={() => { handleCheckboxChange(item.id) }}


                                                            />
                                                            <label htmlFor={`option-${index}`} >
                                                                <figure>
                                                                    <img
                                                                        onError={(e: any) => e.target.src = "images/fely-beauty.jpg"}
                                                                        src={item?.image_details?.file_path} alt={`Category ${index}`} />
                                                                    <span className="icon-check" ></span>
                                                                </figure>
                                                                <p>{capitalizeFirstLetter(item?.name)}</p>

                                                            </label>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                            <Errormessages errors={errors} name="category" />
                                        </div>

                                        <div className='serviceSelect' >
                                            <h6><FormattedMessage id="services" />*<small>(<FormattedMessage id="add_services_your_salon_provide" />.)</small></h6>
                                            <CreatableSelect
                                                components={components}
                                                inputValue={inputValue}
                                                isClearable isMulti
                                                menuIsOpen={false}
                                                onChange={(selected) => {
                                                    trigger("services")
                                                    setValueData(selected)
                                                }}
                                                onInputChange={(newValue) => {
                                                    setInputValue(newValue)
                                                    trigger("services")
                                                }}
                                                onKeyDown={handleKeyDown}
                                                placeholder={intl.formatMessage({ id: 'enter_services' })}

                                                value={value}
                                            />
                                            <Errormessages errors={errors} name="services" />

                                        </div>

                                        <div className='row gy-4 fileUpload'>
                                            <div className='col-md-6 salonOwner'>
                                                <h6><FormattedMessage id="upload_proof_owner" />*</h6>
                                                {
                                                    ownerImage || ownerImageData ? (
                                                        <>
                                                            <div className='imageUpload'>
                                                                <img src={ownerImage ? URL.createObjectURL(ownerImage) : ownerImageData} alt={`Selected Image ${ownerImage}`} />
                                                                <button className='deleteBTN' onClick={(index: any) => {
                                                                    setOwnerImage(null)
                                                                    setOwnerImageData(null)
                                                                    setValue("ownerimage", '')
                                                                }}><span className="icon-close-line"></span></button>
                                                            </div>
                                                        </>
                                                    ) :
                                                        <>
                                                            <div className='imageUpload'>
                                                                <span className="icon-upload"></span>
                                                                <input type='file' className='form-control' onChange={(e: any) => {
                                                                    handleOwnerImage(e)
                                                                    trigger("ownerimage")
                                                                }} />
                                                            </div>
                                                        </>
                                                }
                                                <Errormessages errors={errors} name="ownerimage" />

                                            </div>
                                            <div className='col-md-6 BusinessPhoto'>
                                                <h6><FormattedMessage id="business_photos" /> </h6>
                                                {/* <div className='form-text mb-2'>Select only 1mb file </div> */}
                                                <div className='row g-2'>


                                                    {
                                                        selectedImages?.map((item: any, index: any) => {
                                                            return (
                                                                <ProfileImageItem
                                                                    key={index}
                                                                    onImageRemove={(file: any) => handleRemoveImage(item?.media_id, index)}
                                                                    onImageSelect={(file: any) => handleImage(file, index)}
                                                                    index={index}
                                                                    image={item}
                                                                    {...register("image")}
                                                                />
                                                            )
                                                        }
                                                        )
                                                    }

                                                    {/* Add Button Of Images */}
                                                    {
                                                        selectedImages?.length <= 9 && <div className='col-6 col-sm-4 d-flex align-items-center justify-content-center'>
                                                            <button type='button' className='btn p-2' onClick={handleImageAdd}> <span className="icon-plus f-30"></span></button>
                                                        </div>
                                                    }

                                                    {errors.image && (
                                                        <Errormessages errors={errors} name="image" />

                                                    )}
                                                </div>

                                                {/* <Link to="/profile-details" className="btn btn-fill w-100 my-4">Continue</Link> */}
                                                <Button text={<FormattedMessage id="continue" /> as any} className="btn btn-fill w-100 my-4" type="submit" isLoading={companyProfile?.loading} />
                                                {/* <ComponeyProfileDetails data="eeeE"  onSubmit = {onSubmit}/> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default React.memo(Profile);